import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '什么是今日同人库？',
    a: '今日同人库是一个每日整理同人作品更新动态的资讯站点，汇总当日今日更新、最新汉化与新作连载进度，方便读者集中追更。',
  },
  {
    q: '如何知道某部作品今天是否更新？',
    a: '进入「今日更新速递」板块即可查看当日更新作品与最新章节标题，也可按分类和连载状态筛选，关注的作品更新一目了然。',
  },
  {
    q: '作品的汉化进度在哪里查看？',
    a: '在作品详情页可以看到最新汉化章节与已汉化章节数，标记为「汉化完成」的作品表示全部分卷均已汉化完结。',
  },
  {
    q: '新作连载的预告信息从哪里获取？',
    a: '在「汉化连载·追更推荐」板块的「新作预告」分栏，以及各分类页顶部，都会展示即将开坑的新作信息。',
  },
];

export default function FaqPreview() {
  return (
    <section className="px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2">
          <p className="flex items-center gap-2 text-secondary-700 text-sm font-medium">
            <i className="ri-question-answer-line"></i> HELP CENTER
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">追更常见问题</h2>
          <p className="mt-3 text-foreground-500 text-sm leading-relaxed">
            关于今日同人库的使用方式、更新机制与汉化进度说明，这里为你整理了读者最常问到的问题。
          </p>
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-colors whitespace-nowrap"
          >
            查看完整追更指南 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="lg:col-span-3 space-y-3">
          {faqs.map((f) => (
            <details key={f.q} className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden">
              <summary className="flex items-center justify-between gap-3 px-5 py-4 cursor-pointer list-none">
                <span className="font-heading text-base font-semibold text-foreground-900">{f.q}</span>
                <i className="ri-add-line text-xl text-foreground-400 group-open:rotate-45 transition-transform shrink-0"></i>
              </summary>
              <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}